import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  PartyActiveInactive,
  deleteParty,
  getAllParty,
} from "./services/party.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  SetPartyID,
  clearFilterParty,
  clearPartyDetail,
  clearPartyID,
  setFilterParty,
} from "./partySlice";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomFilterCellProps,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Switch } from "@progress/kendo-react-inputs";
import { LoadingPanel } from "../../components/layout/Loading";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import CommonFilterCell from "../../components/common/GlobalCommonFilterCell";

const Party: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(clearPartyDetail());
      dispatch(setCurrentPage(0));
    };
  }, []);

  const handlePartyCreate = () => {
    navigate("/party/create");
  };
  return (
    <>
      <DeletePartyDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Vepari List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handlePartyCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <PartyGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const PartyGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const PartyList = useAppSelector((state) => state.party.PartyList);
  const loading = useAppSelector((state) => state.party.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterParty = useAppSelector((state) => state.party.FilterParty);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  useEffect(() => {
    const payload = {
      ...FilterParty,
      party_no: FilterParty.party_no ? +FilterParty.party_no : null,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllParty(payload));
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const MyEditCommandCell = (props: any) => {
    const handleEditItem = (ID: number) => {
      navigate("/party/edit", { state: { party_guid: ID } });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteParty"));
      dispatch(SetPartyID(ID));
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem.party_guid)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.party_guid)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 7 || props.index === 8 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );
  const MyActiveInActtiveCommandCell = (props: any) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.isactive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        party_guid: props.dataItem.party_guid,
        isactive: !IsActive,
      };
      dispatch(PartyActiveInactive(data)).then((response: any) => {
        const payload = {
          party_name: "",
          limit: +pageLimit,
          skip: +currentPage * +pageLimit,
        };
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllParty(payload));
        } else {
          dispatch(getAllParty(payload));
        }
      });
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props.tdProps.style, textAlign: "center" }}
      >
        <Tooltip anchorElement="target" position="top" parentTitle={true}>
          <div title={`Set ${IsActive ? "Inactive" : "Active"}.`}>
            <Switch
              disabled={isEditAccess ? false : true}
              name="IsActive"
              checked={IsActive}
              onChange={handleActiveInActive}
              size="small"
            />
          </div>
        </Tooltip>
      </td>
    );
  };

  const PartyFilterCell = React.useCallback(
    (props: GridCustomFilterCellProps) => (
      <CommonFilterCell
        {...props}
        numberfiels={["party_no"]}
        filterSelector={(state) => state.party.FilterParty}
        setFilterAction={setFilterParty}
        clearFilterAction={clearFilterParty}
        fetchDataAction={getAllParty}
        pagination={{ case: "lowercase" }}
      />
    ),
    [],
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        className="responsive-table"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={filter ? filterBy(PartyList, filter) : PartyList}
        total={PartyList[0]?.itemcount || PartyList.length}
        onFilterChange={handleFilterChange}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="party_name"
          title="Vepari Name"
          width={250}
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/party/edit", {
                      state: { party_guid: props.dataItem?.party_guid },
                    })
                  }
                >
                  {props.dataItem?.party_name}
                </div>
              </td>
            ),
            filterCell: PartyFilterCell,
          }}
        />
        <Column
          field="party_nick_name"
          title="Vepari Nick Name"
          width={160}
          cells={{ filterCell: PartyFilterCell }}
        />
        <Column
          field="party_no"
          title="Vepari No"
          width={120}
          cells={{ filterCell: PartyFilterCell }}
        />
        <Column
          field="mobile_no"
          title="Phone No"
          width={150}
          cells={{ filterCell: PartyFilterCell }}
        />
        <Column
          field="pan_no"
          title="PAN No"
          width={150}
          cells={{ filterCell: PartyFilterCell }}
        />
        <Column
          field="gst_no"
          title="GST No"
          width={160}
          cells={{ filterCell: PartyFilterCell }}
        />
        <Column
          width={185}
          field="provide_bank_details"
          title="Bank Details Provided"
          filterable={false}
          cells={{
            data: (props: any) => (
              <td>
                {props.dataItem?.provide_bank_details ? (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p
                      style={{
                        textAlign: "center",
                        margin: "0",
                        background: "#c1fbc1",
                        width: "50px",
                        color: "green",
                        fontWeight: "bold",
                        borderRadius: "4px",
                      }}
                    >
                      YES
                    </p>
                  </div>
                ) : (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p
                      style={{
                        textAlign: "center",
                        margin: "0",
                        background: "#fdc4c4",
                        width: "50px",
                        color: "red",
                        fontWeight: "bold",
                        borderRadius: "4px",
                      }}
                    >
                      NO
                    </p>
                  </div>
                )}
              </td>
            ),
          }}
        />

        <Column
          field="Status"
          title="Status"
          cells={{ data: MyActiveInActtiveCommandCell }}
          width={"90px"}
          filterable={false}
          locked={true}
        />
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="item_guid"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeletePartyDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const PartyID = useAppSelector((state) => state.party.PartyID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteParty(ID));
      dispatch(setCurrentPage(0));
      const payload = {
        party_name: "",
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload?.Data.Status === 200) {
        dispatch(getAllParty(payload));
        dispatch(closeDialog());
        dispatch(clearPartyID());
      } else {
        dispatch(getAllParty(payload));
        dispatch(closeDialog());
        dispatch(clearPartyID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteParty" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Vepari?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Vepari?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(PartyID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Party;
